import { apiMillennium } from '../../api'

const AwaitAnalisys = async () => {
	const res = await apiMillennium.get('/ag-analise')
	return res
}

export default AwaitAnalisys